import P404 from '@/common/404.vue';

import AccountSettings from './pages/AccountSettings.vue';
import PublishedSurvey from './pages/PublishedSurvey.vue';

const routes = [
	{ path: '/t/:slug([A-Za-z0-9\\-]{9})/', component: PublishedSurvey, name: 'published-survey', props: true },
	{ path: '/t/:slug([A-Za-z0-9\\-]{9})/embed/', component: PublishedSurvey, name: 'published-survey-embed', props: true },
	//{ path: '/p/s/:uuid([A-Za-z0-9\\-]{36})/complete/', component: PublishedSurvey, name: 'published-survey-complete', props: true },
	//{ path: '/b/:uuid([A-Za-z0-9\\-]{36})/closed/', component: PublishedBoardClosed, name: 'published-board-closed', props: true },
	//{ path: '/p/me/', component: AccountSettings, name: 'account-settings'},
	{ path: '/:catchAll(.*)*', component: P404, name: '404'}
];

export default routes;
